<!-- 签约管理 -->
<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="签约编号" prop="signId">
        <el-input v-model="searchData.signId" placeholder="请输入" clearable style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="statusList">
        <el-select v-model="searchData.statusList" placeholder="请选择" clearable multiple>
          <el-option v-for="(item, index) in InvoiceSignStatusEnum" :key="index" :label="item.description" :value="item.enumCode"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="签约年份" prop="signYear">
        <el-select v-model="searchData.signYear" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="签约公司" prop="signCompanyNameList">
        <el-select v-model="searchData.signCompanyNameList" placeholder="请选择" clearable multiple style="width: 100%">
          <el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="userName">
        <el-input v-model="searchData.userName" placeholder="请输入" clearable style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="身份证" prop="idCard">
        <el-input v-model="searchData.idCard" placeholder="请输入" clearable style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="签约时间" prop="signDate">
        <!-- 签约时间 -->
        <el-date-picker
          :key="'day-picker'"
          v-model="signDate"
          type="daterange"
          :picker-options="dayPickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="handleDayChange"
          :clearable="true"
        />
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button ghost size="medium" @click="addDialogVisible = true">新增</el-button>
        <el-button ghost size="medium" @click="handleCancelSign">合同作废</el-button>
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh">
      <el-table-column type="selection" width="55" align="center"> </el-table-column>
      <el-table-column label="操作" prop="action" width="200" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleCopyLink(scope.row)">复制链接</el-link>
          <el-link style="margin-left: 12px;" type="primary" @click="handleViewDetail(scope.row)">查看详情</el-link>
          <el-link style="margin-left: 12px;" type="primary" @click="handleReview(scope.row)" v-if="$store.getters.roleId === 12 && scope.row.status === 105">审核</el-link>
        </template>
      </el-table-column>
      <el-table-column label="签约编号" prop="signId" min-width="180"></el-table-column>
      <el-table-column label="姓名" prop="userName" min-width="100"></el-table-column>
      <el-table-column label="手机号" prop="phone" min-width="120"></el-table-column>
      <el-table-column label="身份证号" prop="idCard" min-width="180"></el-table-column>
      <el-table-column label="签约公司" prop="signCompanyName" min-width="150">
        <template slot-scope="scope">
          {{ getCompanyName(scope.row.signCompanyName) }}
        </template>
      </el-table-column>
      <el-table-column label="签约年份" prop="signYear" min-width="100"></el-table-column>
      <el-table-column label="状态" prop="status" min-width="100">
        <template slot-scope="scope">
          <span>{{ getStatusLabel(scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="签约时间" prop="signDate" min-width="160"></el-table-column>
      <el-table-column label="操作人" prop="operator" min-width="100"></el-table-column>
      <el-table-column label="创建时间" prop="lastModifiedTime" min-width="160"></el-table-column>
      <el-table-column label="合同结束时间" prop="signEndDate" min-width="160"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.rows"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新建签约弹窗 -->
    <SignAddDialog :dialog-visible.sync="addDialogVisible" @success="handleAddSuccess" />
    <!-- 审核弹窗 -->
    <BatchReviewDialog :dialog-visible.sync="batchReviewDialogVisible" :sign-id="currentSignId" @success="handleBatchReviewSuccess" />
  </div>
</template>
<script>
import { getSignPageList, getCompanyEnum, getSignUrl, cancelSign } from '@/api/invoiceManagement'
import SignAddDialog from './components/SignAddDialog.vue'
import BatchReviewDialog from './components/BatchReviewDialog.vue'
import enumMixin from '@/views/COldForNewService/enumMixin.js'
import dayjs from 'dayjs'
export default {
  components: {
    SignAddDialog,
    BatchReviewDialog
  },
  mixins: [enumMixin],
  data() {
    return {
      tableData: [],
      tableLoading: false,
      total: 0,
      pagination: {
        page: 1,
        rows: 10
      },
      signDate: [],
      searchData: {
        signId: '',
        userName: '',
        statusList: [],
        idCard: '',
        signCompanyNameList: [],
        signYear: new Date().getFullYear()
      },
      // 日期选择器配置
      dayPickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          // 选择第一个日期后，记录下来
          if (minDate && !maxDate) {
            this.pickDate = minDate.getTime()
          }
          // 选择完成后重置
          if (maxDate) {
            this.pickDate = null
          }
        },
        disabledDate: time => {
          // 不能选择未来日期
          if (time.getTime() > Date.now()) {
            return true
          }
          // 如果已经选择了第一个日期，限制范围在1天到1年之间
          if (this.pickDate) {
            const minTime = this.pickDate - 365 * 24 * 60 * 60 * 1000
            const maxTime = this.pickDate + 365 * 24 * 60 * 60 * 1000
            return time.getTime() < minTime || time.getTime() > maxTime
          }
          return false
        }
      },
      // 记录选择的第一个日期
      pickDate: null,
      // 新建弹窗相关
      addDialogVisible: false,
      // 审核弹窗相关
      batchReviewDialogVisible: false,
      currentSignId: '',
      // 签约公司枚举
      companyOptions: [],
      // 签约年份枚举（近10年）
      yearOptions: this.generateYearOptions()
    }
  },
  created() {
    this.getCompanyEnum()
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.tableLoading = true
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      try {
        const res = await getSignPageList(params)
        if (res.statusCode === 200) {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '请求失败')
        }
      } catch (error) {
        console.error('获取签约列表失败', error)
      } finally {
        this.tableLoading = false
      }
    },
    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    // 重置
    resetForm() {
      this.$refs.searchData.resetFields()
      this.signDate = []
      this.searchData.startSignTime = ''
      this.searchData.endSignTime = ''
      this.pickDate = null
      this.pagination.page = 1
      this.getList()
    },
    // 签约时间改变
    handleDayChange(val) {
      if (val && val.length === 2) {
        this.searchData.startSignTime = dayjs(val[0]).format('YYYY-MM-DD 00:00:00')
        this.searchData.endSignTime = dayjs(val[1]).format('YYYY-MM-DD 23:59:59')
      } else {
        this.searchData.startSignTime = ''
        this.searchData.endSignTime = ''
      }
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 获取状态标签
    getStatusLabel(status) {
      const option = this.InvoiceSignStatusEnum.find(item => item.enumCode === String(status))
      return option ? option.description : ''
    },
    // 新建成功回调
    handleAddSuccess() {
      this.getList()
    },
    // 复制链接
    async handleCopyLink(row) {
      try {
        const res = await getSignUrl({ signId: row.signId })
        if (res.statusCode === 200 && res.data) {
          this.copyToClipboard(res.data)
          this.$message.success('链接已复制到剪贴板')
        } else {
          this.$message.error(res.message || '获取链接失败')
        }
      } catch (error) {
        console.error('获取签约链接失败', error)
        this.$message.error('获取链接失败')
      }
    },
    // 查看详情
    handleViewDetail(row) {
      this.$router.push({
        path: '/invoiceManagement/contractManagement/detail',
        query: {
          signId: row.signId
        }
      })
    },
    // 复制到剪贴板
    copyToClipboard(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    },
    // 单条审核
    handleReview(row) {
      this.currentSignId = row.signId
      this.batchReviewDialogVisible = true
    },
    // 批量审核成功回调
    handleBatchReviewSuccess() {
      this.getList()
    },
    // 合同作废
    async handleCancelSign() {
      const selectedRows = this.$refs.checktableData.selection
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning('请至少选择一条签约记录')
        return
      }
      const signIds = selectedRows.map(row => row.signId)
      try {
        await this.$confirm('确认作废吗？作废后，签约链接将失效且无法恢复，是否确认？', '合同作废', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await cancelSign({ signIds })
        if (res.statusCode === 200) {
          this.$message.success('操作成功')
          this.getList()
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('合同作废失败', error)
          this.$message.error('操作失败')
        }
      }
    },
    // 获取公司名称
    getCompanyName(code) {
      const companyMap = {
        ZH: '珠海',
        CS: '长沙',
        WH: '芜湖',
        SJZ: '石家庄',
        TJ: '天津',
        ZZ: '郑州'
      }
      return companyMap[code] || code
    },
    // 生成年份枚举（近10年，今年在前）
    generateYearOptions() {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let i = currentYear; i >= currentYear - 9; i--) {
        years.push(i)
      }
      return years
    },
    // 获取签约公司枚举
    async getCompanyEnum() {
      try {
        const res = await getCompanyEnum()
        if (res.statusCode === 200 && res.data) {
          const companyMap = {
            ZH: '珠海',
            CS: '长沙',
            WH: '芜湖',
            SJZ: '石家庄',
            TJ: '天津',
            ZZ: '郑州'
          }
          this.companyOptions = res.data.map(item => ({
            label: companyMap[item] || item,
            value: item
          }))
        }
      } catch (error) {
        console.error('获取签约公司枚举失败', error)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.row-bg {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/invoiceManagement/contractManagement/index.vue